export const PERMISSOES = {

  DESENVOLVEDOR: {
    MOCK: 'logistica.desenvolvedor:mock',
  },

  CENTROS_CUSTO: {
    CRIAR: 'logistica.centros_custos:create',
    LISTAR: 'logistica.centros_custos:find_all',
    LISTAR_UM: 'logistica.centros_custos:find_one',
    VISUALIZAR: 'logistica.centros_custos:view',
    EDITAR: 'logistica.centros_custos:update',
    EXCLUIR: 'logistica.centros_custos:delete',
  },

  SERVICOS: {
    LISTAR: 'logistica.servicos:find_all',
    LISTAR_UM: 'logistica.servicos:find_one',
    VISUALIZAR: 'logistica.servicos:view',
    CRIAR: 'logistica.servicos:create',
    EDITAR: 'logistica.servicos:update',
    EXCLUIR: 'logistica.servicos:delete',
  },

  REMESSAS: {
    LISTAR: 'logistica.remessas:find_all',
    LISTAR_UM: 'logistica.remessas:find_one',
    VISUALIZAR: 'logistica.remessas:view',
    CRIAR: 'logistica.remessas:create',
    EDITAR: 'logistica.remessas:update',
    EXCLUIR: 'logistica.remessas:delete',
    UPLOAD: 'logistica.remessas:upload',
    PDF: 'logistica.remessas:pdf',
    PROCESSAR: 'logistica.remessas:process',
    CANCELAR: 'logistica.remessas:cancel',
    ROMANEIO: 'logistica.remessas:romaneio',
  },

  OBJETOS: {
    ADMIN: 'logistica.objetos:admin',
    LISTAR: 'logistica.objetos:find_all',
    LISTAR_UM: 'logistica.objetos:find_one',
    VISUALIZAR: 'logistica.objetos:view',
    CRIAR: 'logistica.objetos:create',
    EDITAR: 'logistica.objetos:update',
    EXCLUIR: 'logistica.objetos:delete',
    EMITIR: 'logistica.objetos:emitir',
    POSTAR: 'logistica.objetos:postar',
    CANCELAR: 'logistica.objetos:cancelar',
    ENTREGAR: 'logistica.objetos:entregar',
    DEVOLVER: 'logistica.objetos:devolver',
  },

  RASTREIOS: {
    BUSCAR: 'logistica.rastreios:find',
  },

  FATURAS: {
    LISTAR: 'logistica.faturas:find_all',
    LISTAR_UM: 'logistica.faturas:find_one',
    VISUALIZAR: 'logistica.faturas:view',
    CRIAR: 'logistica.faturas:create',
    EDITAR: 'logistica.faturas:update',
    EXCLUIR: 'logistica.faturas:delete',
    UPLOAD: 'logistica.faturas:upload',
    CONCILIAR: 'logistica.faturas:conciliar',
  },

  ITENS_FATURA: {
    LISTAR: 'logistica.items:find_all',
    LISTAR_UM: 'logistica.items:find_one',
    VISUALIZAR: 'logistica.items:view',
    CONCILIAR: 'logistica.items:conciliar',
  },

  FILTRO_SETOR: {
    CADASTRO: 'logistica.filtros:cadastro',
    FARMACIA: 'logistica.filtros:farmacia',
    ADMINISTRATIVO: 'logistica.filtros:administrativo',
    COMERCIAL: 'logistica.filtros:comercial',
    INADIMPLENCIA: 'logistica.filtros:inadimplencia',
    TECNOLOGIA_DA_INFORMACAO: 'logistica.filtros:tecnologia_da_informacao',
    RECURSOS_HUMANOS: 'logistica.filtros:recursos_humanos',
    COMUNICACAO: 'logistica.filtros:comunicacao',
    FINANCEIRO: 'logistica.filtros:financeiro',
    MARKETING: 'logistica.filtros:marketing',
    SECRETARIA: 'logistica.filtros:secretaria',
    RELACIONAMENTO_REDE: 'logistica.filtros:relacionamento_rede',
    AIS: 'logistica.filtros:ais',
    TODOS: 'logistica.filtros:todos_filtros',
  },

} as const;